<template>
    <a-modal title="覆盖所有" :visible="isshow" width="400px" @cancel="handleCancelF">
        <div class="processBox">
            <p>用 {{params.appenv}} 数据覆盖 {{params.appenv_b}}</p>
        </div>


        <template slot="footer">
            <a-button key="submit" type="primary" :loading="tloading" @click="handleOk">
                开始执行
            </a-button>
        </template>
    </a-modal>
</template>

<script>

export default ({
    data(){
        return {
            params:{},
            tloading:false,
            isshow:false,
            percent:0,
        }
    },
    methods:{
        init(params){
            //开始覆盖所有
            this.params = params
            this.isshow = true;
        },
        handleOk(){
            let that = this
            that.tloading = true;
            that.$store.dispatch({
                type: "timetask/coverall",
                params:that.params
            }).then((res)=>{
                if(res.status == 200 && res.data.success == '1'){
                    console.log('success')
                    this.handleCancelF()
                }
                that.tloading = false;
            }).catch(() => {
                that.tloading = false;

            });
        },
        handleCancelF(){
            this.$emit('handleOver')
            this.isshow = false;
        }
        
    }
})
</script>

<style scoped>
    .processBox{
        text-align: center;
    }
    .processBox p{
        margin-top: 8px;
    }
    .processBox span{
        padding: 0 10px;
    }
</style>
